import { createAction, handleActions } from 'redux-actions';
import { takeLatest } from 'redux-saga/effects';
import * as scalpAPI from '../lib/api/scalp';
import { getScalpHistory, getScalpResult } from 'api/@scalp/api_scalp';
import { dummyHistory, scalpDummyHistory } from 'containers/scalp/dummyData';
import { scalpResultDummaytData } from 'containers/scalp/dummyDiagnosisItems';

import createRequestSaga, {
  createRequestActionTypes,
} from '../lib/createRequestSaga';
import * as ds from '../lib/scalpDataService';
import moment from 'moment';
// Action Type 정의
const [GET_SCALP_RESULT, GET_SCALP_RESULT_SUCCESS, GET_SCALP_RESULT_FAILURE] =
  createRequestActionTypes('diagnosis/GET_SCALP_RESULT');

const SET_DIAGNOSIS_ITEMS_FOR_SCALP_TYPE =
  'stadiagnosistus/SET_DIAGNOSIS_ITEMS_FOR_SCALP_TYPE';

export const [GET_SCALP_TYPE, GET_SCALP_TYPE_SUCCESS, GET_SCALP_TYPE_FAILURE] =
  createRequestActionTypes('diagnosis/GET_SCALP_TYPE');

const [GET_GRAPH_DATA, GET_GRAPH_DATA_SCUCCESS, GET_GRAPH_DATA_FAILURE] =
  createRequestActionTypes('diagnosis/GET_GRAPH_DATA');

// 로그인 하지 않은 유저 단일 두피 데이터 요청 서버 API (X)
const GET_DUMMY_SCALP_RESULT = 'GET_DUMMY_SCALP_RESULT';

// Action 생성
export const getScalpResultAction = createAction(
  GET_SCALP_RESULT,
  ({ userId, analysisId }) => ({ userId, analysisId }),
);

// 로그인 하지 않은 유저 단일 두피 데이터 요청 서버 API (X)
export const getDummyScalpResult = createAction(GET_DUMMY_SCALP_RESULT);

export const setDiagnosisItemForScalpType = createAction(
  SET_DIAGNOSIS_ITEMS_FOR_SCALP_TYPE,
  (diagnosis_items) => diagnosis_items,
);
export const getScalpType = createAction(
  GET_SCALP_TYPE,
  ({ user_id, diagnosis_items }) => ({ user_id, diagnosis_items }),
);

export const getGraphData = createAction(GET_GRAPH_DATA, ({ user_id }) => ({
  user_id,
}));

// saga 생성
export const getScalpResultSaga = createRequestSaga(
  GET_SCALP_RESULT,
  getScalpResult,
);

export const getScalpTypeSaga = createRequestSaga(
  GET_SCALP_TYPE,
  scalpAPI.getScalpType,
);

export function* scalpSaga() {
  yield takeLatest(GET_SCALP_RESULT, getScalpResultSaga);
  yield takeLatest(GET_SCALP_TYPE, getScalpTypeSaga);
}

const initialState = {
  scalpResult: null,
  scalpHistory: null,
  diagnosis_items: null,
  scalpGraphData: null,
  scalpGraphDataError: null,
  initScalpGraphDataError: null,
  latestScalpGraphData: null,
  scalpDummyGraphData: null,
  scalpDummyFilterData: null,
};

export default handleActions(
  {
    // 로그인 하지 않은 유저 더미 단일 두피 분석 정보 불러오기 요청 서버 API 요청(X)
    [GET_DUMMY_SCALP_RESULT]: (state) => ({
      ...state,
      scalpResult: scalpResultDummaytData,
    }),
    // 단일 두피 분석 정보 불러오기 요청
    [GET_SCALP_RESULT]: (state) => ({
      ...state,
      scalpResult: initialState.scalpResult,
    }),
    // 단일 두피 분석 정보 불러오기 성공
    [GET_SCALP_RESULT_SUCCESS]: (state, result) => {
      return {
        ...state,
        scalpResult: {
          ...result.meta.detailScalpAnalysis,
          analysisItems: Object.keys(
            result.meta.detailScalpAnalysis.analysisItems,
          ).map((key) => {
            return {
              item: key,
              ...result.meta.detailScalpAnalysis.analysisItems[key],
            };
          }),
        },
      };
    },
    // 단일 두피 분석 정보 불러오기 실패
    [GET_SCALP_RESULT_FAILURE]: (state, { payload: error }) => {
      return {
        ...state,
        checkError: error,
      };
    },

    // 두피진단+문진 보정 두피타입 조회를 위한 parameter를 계산하여 redux에 저장하기 >>> shampoo module에서 바로 가져다 쓸 수 있도록
    [SET_DIAGNOSIS_ITEMS_FOR_SCALP_TYPE]: (
      state,
      { payload: diagnosis_items },
    ) => ({
      ...state,
      diagnosis_items: diagnosis_items,
    }),
    // 두피진단 + 문진 보정 두피타입 조회 성공
    [GET_SCALP_TYPE_SUCCESS]: (state, { payload: result }) => ({
      ...state,
      diagnosisScalpType: result,
    }),
    // 두피진단 + 문진 보정 두피타입 조회 실패
    [GET_SCALP_TYPE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      diagnosisScalpType: error,
    }),
  },
  initialState,
);
